import { PencilSquareIcon } from "@heroicons/react/24/solid";

const EditButton = ({
  buttonText = "Edit",
  className = "",
  onClick,
  disabled = false,
  isForLongText = false,
}) => {
  return (
    <button
      value={buttonText}
      onClick={onClick}
      disabled={disabled}
      type="button"
      className={
        (disabled
          ? `cursor-not-allowed border text-white bg-quaternary opacity-25 `
          : `bg-quaternary border-quaternary text-white hover:text-white  `) +
        `hover:scale-90  bg-quaternary shadow-md h-5  lg:h-6  gap-2 whitespace-pre border-quaternary text-white 
        hover:border-hquaternary hover:bg-hquaternary hover:text-white flex flex-row items-center justify-center 
        text-xs3 border rounded-full  transition duration-500 ease select-none focus:outline-none
         focus:shadow-outline undefined ${
           isForLongText ? `px-3` : `w-16 lg:w-20`
         } ${className}`
      }
    >
      <PencilSquareIcon className="h-4 w-4 -mr-1" />
      <div>{buttonText}</div>
    </button>
  );
};
export default EditButton;
